import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const apiPublic = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export const apiPrivate = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

let _accessToken = null;
export const setAccessToken = (t) => { _accessToken = t; };
export const getAccessToken = () => _accessToken;

apiPrivate.interceptors.request.use((config) => {
    if (_accessToken) config.headers.Authorization = `Bearer ${_accessToken}`;
    return config;
});

let _refreshing = null;
apiPrivate.interceptors.response.use(
    (r) => r,
    async (error) => {
        const prev = error?.config;
        if (error?.response?.status === 401 && !prev?._retry) {
            prev._retry = true;
            try {
                _refreshing = _refreshing || apiPublic.post("/auth/refresh");
                const res = await _refreshing;
                _refreshing = null;
                _accessToken = res.data.access_token;
                prev.headers.Authorization = `Bearer ${_accessToken}`;
                return apiPrivate(prev);
            } catch (e) {
                _refreshing = null;
                _accessToken = null;
                // Let caller handle redirect to /login
                throw e;
            }
        }
        return Promise.reject(error);
    }
);
